module.exports = __webpack_public_path__ + "img/ico_door_1.5359e373.png";